module.exports = __webpack_public_path__ + "static/media/si.8d029633.svg";